// extracted by css-extract-rspack-plugin
export default {"complianceDetailsContainer":"ComplianceDetails_complianceDetailsContainer__n-U42"};